
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function ChorleywoodPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Chorleywood Hertfordshire | Brushour',
    description: 'Professional painting and decorating services in Chorleywood, Hertfordshire. Covering Chorleywood Village, Chorleywood Bottom, and Heronsgate. Fully insured, free quotes available.',
    keywords: 'painters Chorleywood, decorators Chorleywood Hertfordshire, painting services Chorleywood, Chorleywood painters decorators, decorating Heronsgate',
    canonical: `${SITE_URL}/areas/chorleywood`,
    schema: [
      generateAreaPageSchema('Chorleywood', 'Hertfordshire', 'chorleywood', 51.6667, -0.5167, 'WD3'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Chorleywood', url: `${SITE_URL}/areas/chorleywood` },
      ]),
    ],
  });

  const areaData = {
    name: 'Chorleywood',
    region: 'Hertfordshire',
    description: 'Professional painting and decorating services in Chorleywood. We provide high-quality interior and exterior painting, wallpaper installation, and decorative finishes for homes and businesses throughout the Chorleywood area.',
    heroImage: 'https://public.readdy.ai/ai/img_res/9866a733a9852dde50557436083ead9b.jpg',
    serviceAreas: ['Chorleywood Village', 'Chorleywood Bottom', 'Heronsgate', 'Loudwater'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Chorleywood" />
      <AreaTestimonials area="Chorleywood" />
      <AreaCTA area="Chorleywood" />
      <Footer />
    </div>
  );
}
